import i18n from 'modules/core/lib/i18n'

import { PerformanceTargetGroupEnum } from './targetEnums'

export const targetOptions = () => [
  {
    label: i18n.t('performance_process.reviews.target_none'),
    value: null,
    hasOptions: false,
  },
  {
    label: i18n.t('performance_process.reviews.target_selected_all_employees'),
    value: PerformanceTargetGroupEnum.AllEmployees,
    hasOptions: false,
  },
  {
    label: i18n.t('performance_process.reviews.target_manual'),
    value: PerformanceTargetGroupEnum.ByEmployees,
    hasOptions: true,
  },
  {
    label: i18n.t('performance_process.reviews.target_dynamic'),
    description: i18n.t('performance_process.reviews.target_dynamic_description'),
    value: PerformanceTargetGroupEnum.DynamicSelection,
    hasOptions: true,
  },
]
